import type { ContactInfo, NavItem, OperationHours } from '@/types'

export const LANGUAGES = [
  { code: 'en' as const, name: 'English', flag: '🇬🇧' },
  { code: 'bm' as const, name: 'Bahasa Malaysia', flag: '🇲🇾' },
]

export const OPERATION_HOURS: OperationHours = {
  weekdays: {
    en: {
      morning: '9:00 AM until 5:30 PM',
      afternoon: '',
    },
    bm: {
      morning: '9:00 Pagi sehingga 5.30 Petang',
      afternoon: '',
    },
  },
  friday: {
    en: {
      morning: '9:00 AM until 5:30 PM',
      afternoon: '',
    },
    bm: {
      morning: '9:00 Pagi sehingga 5.30 Petang',
      afternoon: '',
    },
  },
  weekend: {
    en: 'Closed',
    bm: 'Tutup',
  },
}

export const CONTACT_INFO: ContactInfo = {
  address: {
    en: `Company Name,
Level 6 & 7, Block D,
Putrajaya Islamic Complex (KIP),
No. 3 Jalan Tun Abdul Razak,
Presint 3, 62100 Putrajaya, Malaysia.`,
    bm: `Nama Syarikat,
Aras 6 & 7, Blok D,
Kompleks Islam Putrajaya (KIP),
No. 3 Jalan Tun Abdul Razak,
Presint 3, 62100 Putrajaya, Malaysia.`,
  },
  phone: '65-0000 5000',
  email: 'info@example.com',
}

export const NAVIGATION_ITEMS: NavItem[] = [
  {
    id: 'admin',
    label: 'Admin',
    labelBM: 'Admin',
    href: '/admin',
  },
  {
    id: 'agent',
    label: 'Agent',
    labelBM: 'Ejen',
    href: '/agent',
  },
]

export const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    url: '#',
    icon: '/images/social/facebook.png',
  },
  {
    name: 'X (Twitter)',
    url: '#',
    icon: '/images/social/x.png',
  },
]

export const GOVERNMENT_LINKS = [
  {
    name: 'Malaysia Government',
    nameBM: 'Kerajaan Malaysia',
    url: 'http://www.malaysia.gov.my',
    logo: '/images/logos/gov.png',
  },
  {
    name: 'Company',
    nameBM: 'Syarikat',
    url: 'http://www.example.com',
    logo: '/images/logos/logo.png',
  },
  {
    name: 'KPDN',
    nameBM: 'KPDN',
    url: 'https://www.kpdn.gov.my',
    logo: '/images/logos/kpdnkk.png',
  },
  {
    name: 'Suruhanjaya Syarikat Malaysia',
    nameBM: 'Suruhanjaya Syarikat Malaysia',
    url: 'http://www.ssm.com.my',
    logo: '/images/logos/ssm.png',
  },
  {
    name: 'Ministry of Health Malaysia',
    nameBM: 'Kementerian Kesihatan Malaysia',
    url: 'http://www.moh.gov.my',
    logo: '/images/logos/kkm.png',
  },
]
